import near_icon from 'assets/near_icon_light.png' // relative path to image 
import { yocto_string_to_near } from 'helpers'

export function PriceLabel({ price_yocto }) {
    const priceNear = yocto_string_to_near(price_yocto, 1);
    return (
        <>
            <div className="price">
                <div style={{ height:'1em', display: "flex", justifyContent: "left", alignItems: "center" }}>
                    <p style={{ fontFamily:"var(--eneftigo-mono-font-family)"}}>{priceNear}</p>
                    <img style={{ margin: "-2px -1px -1px -2px" }} src={near_icon} width="24" height="24" alt="N" />
                </div>
            </div>
        </>
    )
}